import { Box, useTheme } from "@mui/system";
import useStyles from "./styles";
import { Chip, Divider, Paper, Tooltip, Typography } from "@mui/material";
import {
  AccessTimeOutlined,
  FiberManualRecord,
  GroupsOutlined,
  HttpsOutlined,
  PersonOutlineOutlined,
  SpeakerNotesOutlined,
  TagOutlined,
} from "@mui/icons-material";
import dayjs from "dayjs";
export default function ReportsComponent(params) {
  const { reports = [], htmlForText = () => {} } = params;
  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <>
      <Box sx={styles.boxEdit}>
        <Box sx={styles.containerTitleComponent}>
          <SpeakerNotesOutlined sx={{ fontSize: "18px" }} />
          <Typography sx={styles.titleDescription}>Histórico</Typography>
        </Box>
      </Box>
      <Box sx={styles.containerBodyModal}>
        <Box sx={styles.boxBodyModal}>
          <Paper
            variant="outlined"
            elevation={0}
            sx={styles.containerPaperModal}
          >
            {Array.isArray(reports) &&
              reports?.map((report) => (
                <Paper elevation={0} sx={styles.containerPaperMensagem}>
                  {" "}
                  <Box sx={styles.bodyMensagem}>
                    <Box sx={styles.containerTitleReport}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: 1,
                          alignItems: "center",
                          minWidth: 0,
                        }}
                      >
                        <TagOutlined
                          sx={{ color: theme.palette.primary.main }}
                        />
                        <Typography
                          sx={{
                            ...styles.titleReport,
                          }}
                        >
                          {report?.id || ""} | {report?.title || ""}
                        </Typography>
                      </Box>

                      <Tooltip
                        title={dayjs(report?.created).format(
                          "DD/MM/YYYY HH:mm"
                        )}
                      >
                        <Chip
                          sx={styles.chipTime}
                          label={
                            <Box sx={styles.boxTime}>
                              <AccessTimeOutlined fontSize="small" />
                              <Typography
                                sx={{ fontWeight: "bold", fontSize: "12px" }}
                              >
                                {dayjs(report?.created).format(
                                  "DD/MM/YYYY HH:mm"
                                )}
                              </Typography>
                            </Box>
                          }
                        />
                      </Tooltip>
                    </Box>
                    <Box sx={styles.boxPersons}>
                      {report?.origin && report?.destination ? (
                        <Box sx={styles.boxRouting}>
                          <Box sx={styles.containerRouting}>
                            <Typography sx={styles.routing}>De:</Typography>
                            <Box
                              variant="outlined"
                              sx={styles.containerPersons}
                            >
                              <Box sx={styles.containerHeaderMensagem}>
                                <PersonOutlineOutlined sx={styles.iconHeader} />
                                <Tooltip
                                  title={report?.origin?.originPersonName || ""}
                                >
                                  <Typography sx={styles.namePerson}>
                                    {report?.origin?.originPersonName || ""}
                                  </Typography>
                                </Tooltip>
                              </Box>
                              |
                              <Box sx={styles.containerHeaderMensagem}>
                                <GroupsOutlined sx={styles.iconHeader} />
                                <Tooltip
                                  title={report?.origin?.originTeamName || ""}
                                >
                                  <Typography sx={styles.namePerson}>
                                    {report?.origin?.originTeamName || ""}
                                  </Typography>
                                </Tooltip>
                              </Box>
                            </Box>
                          </Box>
                          <Box sx={styles.containerRouting}>
                            <Typography sx={styles.routing}>Para:</Typography>

                            <Box
                              variant="outlined"
                              sx={styles.containerPersons}
                            >
                              <Box sx={styles.containerHeaderMensagem}>
                                <PersonOutlineOutlined sx={styles.iconHeader} />
                                <Tooltip
                                  title={
                                    report?.destination
                                      ?.destinationPersonName || ""
                                  }
                                >
                                  <Typography sx={styles.namePerson}>
                                    {report?.destination
                                      ?.destinationPersonName || ""}
                                  </Typography>
                                </Tooltip>
                              </Box>
                              |
                              <Box sx={styles.containerHeaderMensagem}>
                                <GroupsOutlined sx={styles.iconHeader} />
                                <Tooltip
                                  title={
                                    report?.destination?.destinationTeamName ||
                                    ""
                                  }
                                >
                                  <Typography sx={styles.namePerson}>
                                    {report?.destination?.destinationTeamName ||
                                      ""}
                                  </Typography>
                                </Tooltip>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={styles.boxRouting}>
                          <Box variant="outlined" sx={styles.containerPersons}>
                            <Box sx={styles.containerHeaderMensagem}>
                              <PersonOutlineOutlined sx={styles.iconHeader} />
                              <Tooltip
                                title={report?.createFor?.person?.name || ""}
                              >
                                <Typography sx={styles.namePerson}>
                                  {report?.createFor?.person?.name || ""}
                                </Typography>
                              </Tooltip>
                            </Box>
                            |
                            <Box sx={styles.containerHeaderMensagem}>
                              <GroupsOutlined sx={styles.iconHeader} />
                              <Tooltip
                                title={report?.createFor?.team?.title || ""}
                              >
                                <Typography sx={styles.namePerson}>
                                  {report?.createFor?.team?.title || ""}
                                </Typography>
                              </Tooltip>
                            </Box>
                          </Box>
                        </Box>
                      )}
                      {report?.private && (
                        <Tooltip title={"Relato privado"}>
                          <HttpsOutlined sx={styles.iconHeader} />
                        </Tooltip>
                      )}
                    </Box>
                  </Box>
                  <Divider />
                  <Box sx={styles.containerDescription}>
                    <Typography sx={styles.titleDescription}>
                      {" "}
                      {report?.title || ""}
                    </Typography>
                    <br />
                    <Typography sx={styles.description}>
                      {" "}
                      {htmlForText(report?.description) || ""}
                    </Typography>
                  </Box>
                </Paper>
              ))}
          </Paper>
        </Box>
      </Box>
    </>
  );
}
